import React, { useContext } from 'react'

import { LocaleContext } from '../../locale/i18n'
import { Product, QualitySystem } from '../../logic/catalog'

interface Props {
  product: Product
}

const QualitySystems = ({ product }: Props) => {
  const { t } = useContext(LocaleContext)

  let qualitySystems: QualitySystem[] = []
  if (
    product.accreditation === 'accreditedMethod' ||
    product.accreditation === 'accreditedLab'
  ) {
    qualitySystems.push(product.accreditation)
  }
  qualitySystems = qualitySystems.concat(product.qualitySystems)

  if (qualitySystems.length === 0) {
    return <>{t('productDetails.qualitySystemFallback')}</>
  }

  return (
    <>
      {qualitySystems
        .map(qs => t(`productDetails.qualitySystemValues.${qs}`))
        .join(', ')}
    </>
  )
}

export default QualitySystems
